import { render, staticRenderFns } from "./sbsp-salary-filter.vue?vue&type=template&id=4cf117d7&scoped=true&"
import script from "./sbsp-salary-filter.vue?vue&type=script&lang=js&"
export * from "./sbsp-salary-filter.vue?vue&type=script&lang=js&"
import style0 from "./sbsp-salary-filter.vue?vue&type=style&index=0&id=4cf117d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf117d7",
  null
  
)

export default component.exports